import React from 'react';
import moment from 'moment/moment';
import {useNavigate} from 'react-router-dom';
import {DefaultCell} from '../../Table/Table';

function formatString(inputString) {
  let words = inputString?.split('_');
  let capitalizedWords = words?.map(
    word => word.charAt(0).toUpperCase() + word.slice(1),
  );
  return capitalizedWords?.join(' ');
}
const FBOCustomRow = ({action, rowIndex, cellKeys}) => {
  const navigate = useNavigate();
  const rowClick = () => navigate('/inspections/' + action?.id);

  return (
    <tr
      className='table-row'
      key={action.id}
      style={{
        gridTemplateColumns: `repeat(${cellKeys.length}, 1fr)`,
      }}
      onClick={rowClick}
    >
      <DefaultCell
        value={moment(action?.inspection_date).format('MM/DD/YY')}
        index='due_date'
        rowIndex={rowIndex}
      />
      <DefaultCell
        value={action?.inspection_id}
        index='inspection_id'
        rowIndex={rowIndex}
      />
      <DefaultCell
        value={action?.equipment_name}
        index='equipment_name'
        rowIndex={rowIndex}
      />
      <DefaultCell
        value={action?.facility_name}
        index='facility_name'
        rowIndex={rowIndex}
      />
      <DefaultCell
        value={formatString(action?.period)}
        index='period'
        rowIndex={rowIndex}
      />
    </tr>
  );
};

export default FBOCustomRow;
